import React from 'react';
import {
    Box,
    MenuItem,
    Select,
    Typography
} from '@mui/material';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';
import '../i18n';

export default function LanguageSwitcher({color='white'}) {
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    // Получаем список всех языков из i18n
    const languages = Object.keys(i18n.options.resources);
    const currentLang = i18n.language.split('-')[0];
    // пример: ['en', 'ru', 'es']

    return (
        <Select
            value={currentLang}
            onChange={(e) => changeLanguage(e.target.value)}
            variant="standard"
            disableUnderline
            renderValue={(val) => (
                <Box display="flex" alignItems="center" gap={1}>
                    <LanguageIcon fontSize="small" sx={{ color: color }} />
                    <Typography fontWeight={600} sx={{ color: color }}>
                        {val.toUpperCase()}
                    </Typography>
                </Box>
            )}
            sx={{
                color: '#fff',
                '& .MuiSelect-icon': { color: color },
                '& .MuiSelect-select': { color: color, display: 'flex', alignItems: 'center' },
            }}
        >
            {languages.map((lang) => (
                <MenuItem key={lang} value={lang}>
                    {lang.toUpperCase()}
                </MenuItem>
            ))}
        </Select>
    );
}